// GrowCalc landing config, assets, and copy.

export const GRASS_BG =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_growcalc-privacy/artifacts/lwcki45p_file_000000001bf481f587b5f38a0d3ee256.png";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_growcalc-privacy/artifacts/aa1ptkib_GrowCalc.png";

export const CONTACT_EMAIL = "GrowCalcs@gmail.com";

export const APP_SCREENS = [
  {
    src: "https://static.prod-images.emergentagent.com/jobs/fa60c3dd-3bb3-4293-83d1-d6ead9fe85ef/images/06de4db4c0e36ed9fd99c08371b9dd3df792d147b0da96c77482b9d0192dadc3.jpeg",
    title: "Everything in one view",
    caption: "Weather, soil temperature, GDD, and today's tasks the moment you open the app.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/fa60c3dd-3bb3-4293-83d1-d6ead9fe85ef/images/9e5b528504b5a14571516356f7c0e7aa0a4e4b9a7c732864d7ed7529ccda2ee2.jpeg",
    title: "Track heat, not the calendar",
    caption: "Live growing degree days for pre-emergent and PGR timing that actually works.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/fa60c3dd-3bb3-4293-83d1-d6ead9fe85ef/images/b375b0223d1e62f0f404ee5bf8ed23c94b7a789556aa3f612650556f46594887.jpeg",
    title: "Rates without the napkin math",
    caption: "Turn a label rate and your real square footage into exact pounds and ounces.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/fa60c3dd-3bb3-4293-83d1-d6ead9fe85ef/images/e4eb265c5d17345af9a3d3250ae8228bcfc1c6d13fa071f70a90600d66f558bc.jpeg",
    title: "Remember every application",
    caption: "Product, rate, date, and weather saved together so next season you repeat what worked.",
  },
];

export const MARQUEE_WORDS = [
  "SOIL TEMPERATURE",
  "GROWING DEGREE DAYS",
  "WEATHER-AWARE TIMING",
  "N-P-K CALCULATOR",
  "SOIL pH",
  "APPLICATION LOG",
  "SEASONAL SCHEDULE",
  "SMART REMINDERS",
];

export const STATS = [
  { value: "1h", label: "weather & soil refresh cycle" },
  { value: "195+", label: "countries supported" },
  { value: "15+", label: "features to make lawn care a breeze" },
  { value: "0", label: "trackers, ads, or data sold" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Read the season",
    body: "Soil temperature and growing degree days tell you when a product will actually work. The calendar only tells you what month it is.",
  },
  {
    n: "02",
    title: "Dial in the rate",
    body: "Turn a label's N-P-K and your real square footage into exact pounds and ounces \u2014 no guesswork, no over-application.",
  },
  {
    n: "03",
    title: "Watch the weather",
    body: "Local forecast and soil data pulled from your ZIP so you treat when conditions are right, not whenever you remember.",
  },
  {
    n: "04",
    title: "Log the result",
    body: "Keep the date, product, rate, and pH in one history. Next season you repeat what worked instead of starting over.",
  },
];

export const HOME_SHOT =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_growcalc-privacy/artifacts/o56fwxsf_Screenshot_20260726_103325_GrowCalc.webp";

// One entry per app feature. `img: null` renders a "screenshot coming" slot.
export const FEATURE_LIST = [
  {
    id: "home",
    icon: "Home",
    title: "Home",
    tagline: "Your command center",
    body: "Open the app to a live snapshot of your lawn \u2014 current air and soil temperature, humidity, and wind \u2014 with one-tap access to every tool in GrowCalc.",
    img: null,
    video: "/videos/home.mp4",
    videoWebm: "/videos/home.webm",
    poster: "/videos/home-poster.jpg",
  },
  {
    id: "weather",
    icon: "CloudSun",
    title: "Weather",
    tagline: "See the whole week",
    body: "A 7-day forecast paired with live soil temperature, so you know exactly when conditions are right to feed, spray, or water.",
    img: null,
    video: "/videos/weather.mp4",
    videoWebm: "/videos/weather.webm",
    poster: "/videos/weather-poster.jpg",
  },
  {
    id: "dashboard",
    icon: "LayoutDashboard",
    title: "Dashboard",
    tagline: "Everything in one place",
    body: "A complete overview of what matters: your season, upcoming reminders, running totals, and more \u2014 all on a single screen.",
    img: null,
    video: "/videos/dashboard.mp4",
    videoWebm: "/videos/dashboard.webm",
    poster: "/videos/dashboard-poster.jpg",
  },
  {
    id: "zones",
    icon: "MapPin",
    title: "Zones",
    tagline: "Map every square foot",
    body: "Measure and save your lawn areas as zones, then track products and history for each one independently.",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_growcalc-privacy/artifacts/a1ms2oua_Screenshot_20260726_142534_GrowCalc.webp",
  },
  {
    id: "calculator",
    icon: "Calculator",
    title: "Calculator",
    tagline: "NPK without the guesswork",
    body: "Dial in granular and liquid rates from any product's N-P-K and your real square footage \u2014 exact pounds, ounces, and gallons.",
    img: null,
    video: "/videos/calculator.mp4",
    videoWebm: "/videos/calculator.webm",
    poster: "/videos/calculator-poster.jpg",
  },
  {
    id: "service",
    icon: "Wrench",
    title: "Service",
    tagline: "Keep your gear in check",
    body: "Track equipment, warranties, and service logs so your mower, sprayer, and tools are always season-ready.",
    img: null,
    video: "/videos/service.mp4",
    videoWebm: "/videos/service.webm",
    poster: "/videos/service-poster.jpg",
  },
  {
    id: "warranty",
    icon: "ShieldCheck",
    title: "Warranty",
    tagline: "Receipts & expiry tracker",
    body: "Store every receipt and warranty in one place \u2014 GrowCalc tracks expiry dates and counts down the months left, so you never miss a claim window on your mower, tools, or gear.",
    img: null,
    video: "/videos/warranty.mp4",
    videoWebm: "/videos/warranty.webm",
    poster: "/videos/warranty-poster.jpg",
  },
  {
    id: "photo-journal",
    icon: "Camera",
    title: "Photo Journal",
    tagline: "Watch it transform",
    body: "Document your lawn over time with dated photos and see your progress unfold season by season.",
    img: null,
    images: [
      "https://customer-assets-eiarnc6j.emergentagent.net/job_growcalc-privacy/artifacts/4j528x38_Screenshot_20260726_145853_GrowCalc.webp",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_growcalc-privacy/artifacts/4ncqrnjg_Screenshot_20260726_145905_GrowCalc.webp",
    ],
  },
  {
    id: "ai-assistant",
    icon: "Sparkles",
    title: "AI Assistant",
    tagline: "Diagnose in seconds",
    body: "Chat for advice or snap a photo to identify pests, weeds, and disease \u2014 with treatment guidance grounded in your conditions.",
    img: null,
    video: "/videos/ai-assistant.mp4",
    videoWebm: "/videos/ai-assistant.webm",
    poster: "/videos/ai-assistant-poster.jpg",
  },
  {
    id: "converter",
    icon: "Repeat",
    title: "Converter",
    tagline: "Every unit, instantly",
    body: "Convert rates, areas, volumes, and more on the fly so label math never slows you down in the yard.",
    img: null,
    video: "/videos/converter.mp4",
    videoWebm: "/videos/converter.webm",
    poster: "/videos/converter-poster.jpg",
  },
  {
    id: "products",
    icon: "Package",
    title: "Products",
    tagline: "Your whole arsenal",
    body: "Store your products and pull from a library of 120+ commonly used items, each with label rates ready to log in two taps.",
    img: null,
    video: "/videos/products.mp4",
    videoWebm: "/videos/products.webm",
    poster: "/videos/products-poster.jpg",
  },
  {
    id: "application-log",
    icon: "ClipboardList",
    title: "Application Log",
    tagline: "Never miss an application",
    body: "Track every product application and soil pH reading in one searchable history you can trust when something works \u2014 or doesn't.",
    img: null,
    video: "/videos/application-log.mp4",
    videoWebm: "/videos/application-log.webm",
    poster: "/videos/application-log-poster.jpg",
  },
  {
    id: "calendars",
    icon: "CalendarRange",
    title: "Grass Calendars",
    tagline: "The right plan for your grass",
    body: "Warm and cool-season grass calendars at your fingertips, so you always know what to do this month.",
    img: null,
    video: "/videos/calendars.mp4",
    videoWebm: "/videos/calendars.webm",
    poster: "/videos/calendars-poster.jpg",
  },
  {
    id: "renovation",
    icon: "Sprout",
    title: "Renovation Planner",
    tagline: "Pick a date — plan it backwards",
    body: "Planning a full reno, overseed, sod, or spot repair? Choose your target date and GrowCalc builds a step-by-step timeline backwards \u2014 so every prep, seed, and feed lands right on schedule.",
    img: null,
    video: "/videos/renovation.mp4",
    videoWebm: "/videos/renovation.webm",
    poster: "/videos/renovation-poster.jpg",
  },
  {
    id: "soil-test",
    icon: "Beaker",
    title: "Soil Test Analysis",
    tagline: "Read your lab, get a plan",
    body: "Upload your soil test PDF, snap a photo, or type in the numbers \u2014 GrowCalc reads your lab report and turns it into a clear, tailored amendment plan for your grass.",
    img: null,
    video: "/videos/soil-test.mp4",
    videoWebm: "/videos/soil-test.webm",
    poster: "/videos/soil-test-poster.jpg",
  },
  {
    id: "gdd",
    icon: "Flame",
    title: "Growing Degree Days",
    tagline: "Stop guessing, start timing",
    body: "Real GDD data based on your location to time pre-emergents, treat common pests and fungus, and track your PGR applications.",
    img: null,
    video: "/videos/gdd.mp4",
    videoWebm: "/videos/gdd.webm",
    poster: "/videos/gdd-poster.jpg",
  },
  {
    id: "backup",
    icon: "DatabaseBackup",
    title: "Backup & Import",
    tagline: "Your data, protected",
    body: "Back up your entire GrowCalc setup and import it to a new device in seconds \u2014 zones, products, logs, and history all move with you.",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_growcalc-privacy/artifacts/ilaa3kkc_Screenshot_20260726_153215_GrowCalc.webp",
  },
  {
    id: "archive",
    icon: "Archive",
    title: "Archive & Start Fresh",
    tagline: "Close out the season",
    body: "Archive a finished season and start next year clean \u2014 then download CSV files of your logs to keep every season in one place and take your program to the next level.",
    img: null,
    video: "/videos/archive.mp4",
    videoWebm: "/videos/archive.webm",
    poster: "/videos/archive-poster.jpg",
  },
  {
    id: "arbor-care",
    icon: "TreePine",
    title: "Arbor Care & Growth Log",
    tagline: "Care for every tree & shrub",
    body: "Go beyond the lawn \u2014 track your trees, shrubs, and ornamentals with a dedicated growth log. Record height, health, feedings, and prunings over time, and watch each planting mature season after season.",
    img: null,
    video: "/videos/arbor-care.mp4",
    videoWebm: "/videos/arbor-care.webm",
    poster: "/videos/arbor-care-poster.jpg",
  },
  {
    id: "achievements",
    icon: "Trophy",
    title: "Achievements",
    tagline: "Milestones that celebrate your journey",
    body: "GrowCalc turns steady lawn care into a game \u2014 unlock milestones as you stick with it, from your first season to a full year, and watch your progress bars climb toward the next reward.",
    img: "/videos/achievements.jpg",
    video: null,
    videoWebm: null,
    poster: null,
  },
];

export const FAQ = [
  {
    q: "Do I need an account or subscription to use GrowCalc?",
    a: "Yes. A free GrowCalc account is required to access the app and its features. This lets us securely encrypt and back up your lawn history, product library, photos, warranty records, and reminders — so your data stays private, syncs across devices, and is never lost when you switch phones. We never sell your data, never share it with advertisers, and give you full export and one-tap account deletion at any time.",
  },
  {
    q: "Does GrowCalc work outside the United States?",
    a: "Yes. Weather, GDD, and Bio Watch now support any lat/lon worldwide — with full metric and imperial units.",
  },
  {
    q: "How accurate is the weather data?",
    a: "GrowCalc uses NOAA's NBM model (2.5 km grid, official 11-day CONUS blend) for US forecasts and Open-Meteo's global model everywhere else. Data refreshes hourly with hour-aware rollover so the numbers you see always match the current hour.",
  },
  {
    q: "Can I use GrowCalc for multiple lawns or client properties?",
    a: "Yes. Multi-zone support lets you track front, back, side, and specialty zones independently — or run several properties side-by-side with per-zone dashboards, reminders, and archives.",
  },
  {
    q: "What is AI Photo Diagnosis and how does it work?",
    a: "Snap a photo of a weed, disease, insect damage, or nutrient issue. GrowCalc's AI identifies the problem and returns a step-by-step treatment plan including product suggestions from your library — usually in under 5 seconds.",
  },
  {
    q: "How does the Pro subscription work?",
    a: "Pro unlocks GrowCalc's full precision toolkit — full GDD projections, multi-zone tracking, season archives with CSV export, cocktail mixing, warranty and equipment records, and AI features including up to 10 AI Chats and 5 AI Photo Diagnoses per week. Available as monthly or annual plans — no ads, no data sharing, cancel anytime.",
  },
  {
    q: "Where does my data live and who owns it?",
    a: "Your data is yours. Encrypted at rest, never sold, never used for ads. Full export at any time and one-tap account deletion if you ever want to walk away.",
  },
];
